import Breadcrumb from '@/components/feature/Breadcrumb';
import { SchemaWebPage, SchemaBreadcrumbList, SchemaFAQPage } from '@/components/feature/SchemaOrg';
import { siteInfo, brandStory, honors, stats, faqItems } from '@/mocks/sports';
import { Link } from 'react-router-dom';

export default function AboutPage() {
  return (
    <>
      <SchemaWebPage
        url="/about"
        name={`关于我们 - ${siteInfo.name}`}
        description={`了解九游体育的品牌故事、荣誉资质和联系方式。${siteInfo.description}`}
      />
      <SchemaBreadcrumbList
        items={[
          { name: '首页', url: '/' },
          { name: '关于我们', url: '/about' },
        ]}
      />
      <SchemaFAQPage faqs={faqItems.slice(0, 4)} />

      <div className="pt-24 pb-10 bg-background-100">
        <div className="w-full px-4 md:px-6 mb-6">
          <Breadcrumb items={[{ name: '关于我们' }]} />
        </div>
        <div className="w-full px-4 md:px-6">
          <div className="max-w-4xl mx-auto text-center">
            <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold mb-3">
              关于我们
            </span>
            <h1 className="font-heading text-3xl md:text-5xl font-extrabold text-foreground-950 mb-3">
              {brandStory.title}
            </h1>
            <p className="text-foreground-500 text-sm md:text-lg max-w-2xl mx-auto">
              {brandStory.subtitle}
            </p>
          </div>
        </div>
      </div>

      <section className="w-full py-14 md:py-20 bg-background-50">
        <div className="w-full px-4 md:px-6">
          <div className="max-w-4xl mx-auto">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-12 items-center">
              <div>
                <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-6">
                  品牌故事
                </h2>
                {brandStory.paragraphs.map((p, i) => (
                  <p key={i} className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
                    {p}
                  </p>
                ))}
              </div>
              <div className="relative h-[350px] md:h-[450px] rounded-2xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Modern%20sports%20technology%20office%20with%20large%20display%20screens%20showing%20live%20sports%20data%2C%20contemporary%20workspace%20with%20clean%20design%2C%20warm%20ambient%20lighting%2C%20professional%20atmosphere%2C%20sports%20analytics%20theme%2C%20soft%20neutral%20background&width=800&height=1000&seq=about-brand&orientation=portrait"
                  alt="九游体育品牌"
                  title="九游体育 - 品牌故事"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="w-full py-14 md:py-20 bg-accent-500">
        <div className="w-full px-4 md:px-6">
          <div className="max-w-4xl mx-auto">
            <div className="text-center mb-10 md:mb-14">
              <h2 className="font-heading text-2xl md:text-4xl font-bold text-background-50 mb-3">
                数据见证实力
              </h2>
              <p className="text-background-50/75 text-sm md:text-base">
                我们用数据说话，每一个数字背后都是对体育的热爱与执着
              </p>
            </div>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8">
              {stats.map((stat) => (
                <div key={stat.label} className="text-center">
                  <div className="w-14 h-14 mx-auto mb-4 flex items-center justify-center rounded-2xl bg-background-50/15 backdrop-blur-sm">
                    <i className={`${stat.icon} text-2xl text-background-50`}></i>
                  </div>
                  <div className="font-heading text-2xl md:text-4xl font-extrabold text-background-50 mb-1">
                    {stat.value}
                  </div>
                  <div className="text-sm text-background-50/70 font-medium">
                    {stat.label}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="w-full py-14 md:py-20 bg-background-100">
        <div className="w-full px-4 md:px-6">
          <div className="max-w-4xl mx-auto">
            <div className="text-center mb-10 md:mb-14">
              <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-semibold mb-3">
                荣誉资质
              </span>
              <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
                权威认可与行业荣誉
              </h2>
              <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
                多年来，九游体育凭借卓越的产品和服务，获得了行业内外的一致认可
              </p>
            </div>

            <div className="space-y-3">
              {honors.map((honor, index) => (
                <div
                  key={index}
                  className="flex items-center gap-4 p-4 md:p-5 bg-background-50 rounded-xl"
                >
                  <div className="w-12 h-12 flex-shrink-0 flex items-center justify-center rounded-xl bg-accent-100">
                    <i className="ri-award-line text-xl text-accent-600"></i>
                  </div>
                  <div className="flex-1 min-w-0">
                    <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-900">
                      {honor.title}
                    </h3>
                    <p className="text-xs md:text-sm text-foreground-500">
                      {honor.issuer}
                    </p>
                  </div>
                  <div className="flex-shrink-0">
                    <span className="px-3 py-1.5 rounded-full bg-background-100 text-foreground-600 text-xs font-medium">
                      {honor.year}
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="w-full py-14 md:py-20 bg-background-50">
        <div className="w-full px-4 md:px-6">
          <div className="max-w-4xl mx-auto">
            <div className="text-center mb-10 md:mb-14">
              <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold mb-3">
                联系我们
              </span>
              <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
                期待与您相遇
              </h2>
              <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
                有任何问题或合作意向，欢迎随时联系我们
              </p>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-12">
              <div className="space-y-5">
                <div className="flex items-start gap-4">
                  <div className="w-11 h-11 flex-shrink-0 flex items-center justify-center rounded-xl bg-accent-100">
                    <i className="ri-map-pin-line text-lg text-accent-600"></i>
                  </div>
                  <div>
                    <h3 className="font-heading text-sm font-semibold text-foreground-900 mb-1">公司地址</h3>
                    <p className="text-sm text-foreground-500 leading-relaxed">{siteInfo.address}</p>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <div className="w-11 h-11 flex-shrink-0 flex items-center justify-center rounded-xl bg-primary-100">
                    <i className="ri-mail-line text-lg text-primary-600"></i>
                  </div>
                  <div>
                    <h3 className="font-heading text-sm font-semibold text-foreground-900 mb-1">电子邮箱</h3>
                    <a href={`mailto:${siteInfo.email}`} className="text-sm text-foreground-500 hover:text-primary-500 transition-colors duration-200">
                      {siteInfo.email}
                    </a>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <div className="w-11 h-11 flex-shrink-0 flex items-center justify-center rounded-xl bg-secondary-100">
                    <i className="ri-phone-line text-lg text-secondary-600"></i>
                  </div>
                  <div>
                    <h3 className="font-heading text-sm font-semibold text-foreground-900 mb-1">联系电话</h3>
                    <a href={`tel:${siteInfo.phone}`} className="text-sm text-foreground-500 hover:text-primary-500 transition-colors duration-200">
                      {siteInfo.phone}
                    </a>
                  </div>
                </div>
              </div>

              <div className="bg-background-100 rounded-2xl p-6 md:p-8">
                <h3 className="font-heading text-lg font-bold text-foreground-900 mb-5">
                  发送消息
                </h3>
                <form
                  data-readdy-form
                  id="contact-form"
                  action="https://readdy.ai/api/form/d9rdepknlsngrm4lmakg"
                  method="POST"
                  onSubmit={async (e) => {
                    e.preventDefault();
                    const form = e.currentTarget;
                    const honeypot = (form.querySelector('input[name="phone_alt"]') as HTMLInputElement)?.value?.trim();
                    if (honeypot) {
                      const statusEl = document.getElementById('form-status');
                      if (statusEl) {
                        statusEl.textContent = '消息已发送，我们会尽快回复您！';
                        statusEl.className = 'text-sm text-green-600 mt-3 text-center';
                      }
                      form.reset();
                      return;
                    }
                    const formData = new FormData(form);
                    try {
                      const res = await fetch(form.action, {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
                      });
                      const responseText = await res.text();
                      const statusEl = document.getElementById('form-status');
                      if (!statusEl) return;
                      if (res.ok) {
                        let parsed;
                        try { parsed = JSON.parse(responseText); } catch { parsed = null; }
                        const serverMsg = parsed?.meta?.message || parsed?.message || responseText || '';
                        const isSpam = typeof serverMsg === 'string' && (serverMsg.includes('spam') || serverMsg.includes('form data is spam'));
                        const isOk = parsed?.code === 'OK';
                        if (isOk && !isSpam) {
                          statusEl.textContent = '感谢您的留言，我们会尽快回复您！';
                          statusEl.className = 'text-sm text-green-600 mt-3 text-center';
                          form.reset();
                        } else {
                          statusEl.textContent = serverMsg || '提交失败，请稍后再试';
                          statusEl.className = 'text-sm text-red-500 mt-3 text-center';
                        }
                      } else {
                        statusEl.textContent = '提交失败，请稍后再试';
                        statusEl.className = 'text-sm text-red-500 mt-3 text-center';
                      }
                    } catch {
                      const statusEl = document.getElementById('form-status');
                      if (statusEl) {
                        statusEl.textContent = '网络错误，请稍后再试';
                        statusEl.className = 'text-sm text-red-500 mt-3 text-center';
                      }
                    }
                  }}
                >
                  <div className="space-y-4">
                    <div>
                      <label htmlFor="contact-name" className="block text-sm font-medium text-foreground-700 mb-1.5">
                        您的姓名
                      </label>
                      <input
                        type="text"
                        id="contact-name"
                        name="name"
                        required
                        className="w-full px-4 py-2.5 rounded-lg bg-background-50 border border-background-200 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 transition-colors duration-200"
                        placeholder="请输入您的姓名"
                      />
                    </div>
                    <div>
                      <label htmlFor="contact-email" className="block text-sm font-medium text-foreground-700 mb-1.5">
                        电子邮箱
                      </label>
                      <input
                        type="email"
                        id="contact-email"
                        name="email"
                        required
                        className="w-full px-4 py-2.5 rounded-lg bg-background-50 border border-background-200 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 transition-colors duration-200"
                        placeholder="请输入您的邮箱"
                      />
                    </div>
                    <div>
                      <label htmlFor="contact-message" className="block text-sm font-medium text-foreground-700 mb-1.5">
                        留言内容
                      </label>
                      <textarea
                        id="contact-message"
                        name="message"
                        rows={4}
                        maxLength={500}
                        required
                        className="w-full px-4 py-2.5 rounded-lg bg-background-50 border border-background-200 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 transition-colors duration-200 resize-none"
                        placeholder="请输入您的留言内容（不超过500字）"
                      ></textarea>
                    </div>
                    <div className="honeypot-wrap">
                      <input type="text" name="phone_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly />
                    </div>
                    <button
                      type="submit"
                      className="w-full px-6 py-3 rounded-lg bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-colors duration-200 cursor-pointer whitespace-nowrap"
                    >
                      发送消息
                    </button>
                    <div id="form-status"></div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}